<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 80vw">
      <div class="modal-header">
        <h3>{{ editingRecord ? "Edit" : "Add" }} Diabetes Review</h3>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="saveRecord">
          <div class="form-grid">
            <div class="form-group">
              <label>Review Date *</label>
              <input type="datetime-local" v-model="form.review_date" required class="form-control" />
            </div>

            <div class="form-group ">
              <label>Diabetes Type</label>
              <select v-model="form.diabetes_type"  class="form-control">
                <option value="">Select</option>
                <option value="Type 1">Type 1</option>
<option value="Type 2">Type 2</option>
<option value="Gestational">Gestational</option>
<option value="Other">Other</option>
              </select>
            </div>

            <div class="form-group ">
              <label>Years Since Diagnosis</label>
              <input type="number" v-model="form.duration_years" min="0"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>FBS (mmol/L)</label>
              <input type="number" v-model="form.fbs" step="0.1"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>RBS (mmol/L)</label>
              <input type="number" v-model="form.rbs" step="0.1"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>HbA1c (%)</label>
              <input type="number" v-model="form.hba1c" step="0.1"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>BP Systolic</label>
              <input type="number" v-model="form.bp_systolic"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>BP Diastolic</label>
              <input type="number" v-model="form.bp_diastolic"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>Weight (kg)</label>
              <input type="number" v-model="form.weight_kg" step="0.1"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>Height (cm)</label>
              <input type="number" v-model="form.height_cm" step="0.1"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>BMI</label>
              <input type="number" v-model="form.bmi" step="0.1"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>Treatment Regimen</label>
              <select v-model="form.treatment_regimen"  class="form-control">
                <option value="">Select</option>
                <option value="Diet only">Diet only</option>
<option value="OHA">OHA</option>
<option value="Insulin">Insulin</option>
<option value="OHA + Insulin">OHA + Insulin</option>
              </select>
            </div>

            <div class="form-group ">
              <label>Medication Adherence</label>
              <select v-model="form.medication_adherence"  class="form-control">
                <option value="">Select</option>
                <option value="Good">Good</option>
<option value="Fair">Fair</option>
<option value="Poor">Poor</option>
              </select>
            </div>

            <div class="form-group full-width">
              <label>Current Medications</label>
              <textarea v-model="form.current_medications" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group full-width">
              <label>Foot Exam Findings</label>
              <textarea v-model="form.foot_exam_findings" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group">
              <label class="checkbox-label">
                <input type="checkbox" v-model="form.eye_screening_done" />
                Eye screening done
              </label>
            </div>

            <div class="form-group ">
              <label>Eye Screening Date</label>
              <input type="date" v-model="form.eye_screening_date"  class="form-control" />
            </div>

            <div class="form-group">
              <label class="checkbox-label">
                <input type="checkbox" v-model="form.renal_screening_done" />
                Renal screening done
              </label>
            </div>

            <div class="form-group full-width">
              <label>Complications Screened</label>
              <textarea v-model="form.complications_screened" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group">
              <label class="checkbox-label">
                <input type="checkbox" v-model="form.diet_counseling_given" />
                Diet counseling given
              </label>
            </div>

            <div class="form-group full-width">
              <label>Complications</label>
              <textarea v-model="form.complications" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group ">
              <label>Next Appointment</label>
              <input type="date" v-model="form.next_appointment_date"  class="form-control" />
            </div>

            <div class="form-group full-width">
              <label>Notes</label>
              <textarea v-model="form.notes" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group ">
              <label>Seen By</label>
              <input type="text" v-model="form.seen_by"  class="form-control" />
            </div>
          </div>

          <div class="modal-actions">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
            <button type="submit" class="btn btn-primary" :disabled="saving">
              {{ saving ? "Saving..." : (editingRecord ? "Update" : "Save") + " Review" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";

export default {
  name: "DiabetesReviewModal",
  props: {
    visitId: { type: [Number, String], default: null },
    editRecord: { type: Object, default: null },
  },
  data() {
    return {
      saving: false,
      editingRecord: null,
      form: this.emptyForm(),
    };
  },
  created() {
    if (this.editRecord) {
      this.editingRecord = this.editRecord;
      this.form = {
        ...this.emptyForm(),
        ...this.editRecord,
        review_date: this.toLocalDateTime(this.editRecord.review_date),
      };
    }
  },
  methods: {
    emptyForm() {
      return {
        review_date: this.toLocalDateTime(new Date()),
        diabetes_type: "",
        duration_years: "",
        fbs: "",
        rbs: "",
        hba1c: "",
        bp_systolic: "",
        bp_diastolic: "",
        weight_kg: "",
        height_cm: "",
        bmi: "",
        treatment_regimen: "",
        medication_adherence: "",
        current_medications: "",
        foot_exam_findings: "",
        eye_screening_done: false,
        eye_screening_date: "",
        renal_screening_done: false,
        complications_screened: "",
        diet_counseling_given: false,
        complications: "",
        next_appointment_date: "",
        notes: "",
        seen_by: ""
      };
    },
    toLocalDateTime(value) {
      if (!value) return "";
      const d = new Date(value);
      if (isNaN(d.getTime())) return "";
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    closeModal() {
      this.$emit("close");
    },
    async saveRecord() {
      this.saving = true;
      try {
        const payload = { ...this.form, visit_id: this.visitId };
        let response;
        if (this.editingRecord) {
          response = await generalApiRequest(`diabetes_reviews/${this.editingRecord.id}`, "PUT", payload, 1);
        } else {
          response = await generalApiRequest("diabetes_reviews", "POST", payload, 1);
        }
        if (response.success) {
          this.$emit("saved", response.data);
          this.closeModal();
        } else {
          alert(response.message || "Failed to save record");
        }
      } catch (error) {
        console.error("Error saving record:", error);
        alert("An error occurred while saving");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.mmodal-content { background: white; border-radius: 10px; max-height: 90vh; overflow-y: auto; display: flex; flex-direction: column; }
.modal-header { padding: 20px; background: linear-gradient(135deg, #e53e3e 0%, #9b2c2c 100%); color: white; display: flex; justify-content: space-between; align-items: center; }
.modal-header h3 { margin: 0; font-size: 20px; }
.close { background: rgb(233, 22, 22); border: 1px solid rgb(182, 178, 178); font-size: 1.5rem; color: white; line-height: 1; cursor: pointer; }
.modal-body { padding: 30px; overflow-y: auto; flex-grow: 1; }
.form-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-bottom: 20px; }
.form-group { margin-bottom: 15px; }
.form-group.full-width { grid-column: 1 / -1; }
.form-group label { display: block; margin-bottom: 5px; font-weight: 600; color: #495057; }
.checkbox-label { display: flex !important; align-items: center; gap: 8px; margin-top: 28px; }
.form-control { width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 5px; font-size: 14px; }
.modal-actions { display: flex; justify-content: flex-end; gap: 15px; }
.btn { padding: 10px 25px; border: none; border-radius: 5px; cursor: pointer; font-weight: 600; }
.btn-secondary { background: #6c757d; color: white; }
.btn-secondary:hover { background: #5a6268; }
.btn-primary { background: #9b2c2c; color: white; }
.btn-primary:hover { opacity: 0.9; }
.btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }
@media (max-width: 1200px) { .form-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 768px) { .form-grid { grid-template-columns: 1fr; } }
</style>
